import React, {Component} from 'react';
import {Label, Nav, NavItem, NavLink, TabContent, TabPane} from "reactstrap";
import {getMemberImage, request} from "../../util/APIUtils";
import {b64toBlob, showAxiosError} from "../../util/Helpers";
import {API_BASE_URL} from "../../constants";
import moment from "moment";
import classnames from "classnames";
import Table from "../../components/Table/Table";
import FileSaver from "file-saver";
import Alert from "react-s-alert";

class MemberTransactionHistory extends Component {

    constructor(props) {
        super(props);
        this.state = {
            error: {},
            page: 0,
            size: 10,
            searching: false,
            total: 0,
            manual: false,
            loading: false,
            isLoading: false,
            isNotOwner: false,
            loading2: false,
            searching2: false,
            searchQuery: "",
            members: [],
            users: [],
            workAddress: [],
            permAddress: [],
            activeTab: '1',
            showItem: false,
            selectedItem: [],
            selectedPaths: [],
        };

        this.listMembers = this.listMembers.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.listWorkAddress = this.listWorkAddress.bind(this);
        this.listPermAddress = this.listPermAddress.bind(this);
        this.listUsers = this.listUsers.bind(this);
        this.toggle = this.toggle.bind(this);
        this.showAll = this.showAll.bind(this);
        this.downloadOriginalFile = this.downloadOriginalFile.bind(this);
        this.getCityName = this.getCityName.bind(this);


    }

    listUsers(accessor, direction, page, size) {
        let self = this;
        let sortStr = !!accessor ? ("&sort=" + accessor + ',' + direction) : "&sort=id,desc";
        let searchQuery = !self.state.searchQuery ? '' : '&' + self.state.searchQuery;
        let url = API_BASE_URL + "/envers/user/" + self.props.selectedMember.id + "?page=" + page + "&size=" + size + sortStr + searchQuery
        let params = {
            url: url,
            method: "get",
        };
        console.log(params.url);
        self.setState({loading: true, manual: self.manual === true ? false : self.manual, searching: true});
        request(params)
            .then(function (response) {
                let users = response.data.reverse();
                self.setState({
                    page: page,
                    size: size,
                    total: response.data.totalElements,
                    users,
                    loading: false,
                    searching: false
                });
            }).catch(function (error) {
            self.setState({loading: false, searching: false});
            showAxiosError(error);
        });
    }

    getCitySubDivisionName(cityId, subDivisionId) {
        const citySubdivisions = this.props.citySubdivisions;
        let name;
        if (citySubdivisions && cityId) {
            for (const citySubdivision of citySubdivisions) {
                if (citySubdivision.cityId === cityId) {
                    if (citySubdivision.id === subDivisionId)
                        name = citySubdivision.name
                }
            }
        }
        return name;
    }

    getCityName(cityId) {
        const cities = this.props.cities;
        let name;

        if (cities && cityId) {
            for (const city of cities) {
                if (city.id === cityId) {
                    name = city.ad
                }
            }
        }
        return name;
    }

    listWorkAddress(accessor, direction, page, size) {
        let self = this;
        let sortStr = !!accessor ? ("&sort=" + accessor + ',' + direction) : "&sort=id,desc";
        let searchQuery = !self.state.searchQuery ? '' : '&' + self.state.searchQuery;
        let url = API_BASE_URL + "/envers/address/work/" + self.props.selectedMember.id + "?page=" + page + "&size=" + size + sortStr + searchQuery
        let params = {
            url: url,
            method: "get",
        };
        console.log(params.url);
        self.setState({loading: true, manual: self.manual === true ? false : self.manual, searching: true});
        request(params)
            .then(function (response) {
                let workAddress = response.data.reverse();
                self.setState({
                    page: page,
                    size: size,
                    total: response.data.totalElements,
                    workAddress,
                    loading: false,
                    searching: false
                });
            }).catch(function (error) {
            self.setState({loading: false, searching: false});
            showAxiosError(error);
        });
    }

    listPermAddress(accessor, direction, page, size) {
        let self = this;
        let sortStr = !!accessor ? ("&sort=" + accessor + ',' + direction) : "&sort=id,desc";
        let searchQuery = !self.state.searchQuery ? '' : '&' + self.state.searchQuery;
        let url = API_BASE_URL + "/envers/address/perm/" + self.props.selectedMember.id + "?page=" + page + "&size=" + size + sortStr + searchQuery
        let params = {
            url: url,
            method: "get",
        };
        console.log(params.url);
        self.setState({loading: true, manual: self.manual === true ? false : self.manual, searching: true});
        request(params)
            .then(function (response) {
                let permAddress = response.data.reverse();
                self.setState({
                    page: page,
                    size: size,
                    total: response.data.totalElements,
                    permAddress,
                    loading: false,
                    searching: false
                });
            }).catch(function (error) {
            self.setState({loading: false, searching: false});
            showAxiosError(error);
        });
    }

    listMembers(accessor, direction, page, size) {
        let self = this;
        let sortStr = !!accessor ? ("&sort=" + accessor + ',' + direction) : "&sort=id,desc";
        let searchQuery = !self.state.searchQuery ? '' : '&' + self.state.searchQuery;
        let url = API_BASE_URL + "/envers/member/" + self.props.selectedMember.id + "?page=" + page + "&size=" + size + sortStr + searchQuery
        let params = {
            url: url,
            method: "get",
        };
        console.log(params.url);
        self.setState({loading: true, manual: self.manual === true ? false : self.manual, searching: true});
        request(params)
            .then(function (response) {
                let members = response.data.reverse();
                self.setState({
                    page: page,
                    size: size,
                    total: response.data.totalElements,
                    members,
                    loading: false,
                    searching: false
                });
            }).catch(function (error) {
            self.setState({loading: false, searching: false});
            showAxiosError(error);
        });
    }

    handleSearch(searchQuery) {
        this.setState({
            searchQuery,
            searching: true
        }, () => this.listMembers(this.state.accessor, this.state.direction, this.state.page, this.state.size))
    }

    toggle(tab) {
        this.setState({
            showItem: false,
            activeTab: tab
        })
    }

    async downloadOriginalFile(path) {
        let self = this;
        let fileName;
        let fileData;
        if (path === null || path === " " || path === "" || path === undefined) {
            Alert.warning(
                'İndirilmek istenen dökuman sistemde kayıtlı değildir!', {
                    position: 'top-right',
                    effect: 'stackslide',
                    timeout: 5000
                });
        } else {
            self.setState({isLoading: true});
            await getMemberImage(path).then(response => {
                fileName = response.data.filePath.toString().substring(response.data.filePath.toString().lastIndexOf('/') + 1);
                fileData = response.data.base64File.toString().substring(response.data.base64File.toString().lastIndexOf(',') + 1);
                let blob = b64toBlob(fileData, '');
                FileSaver.saveAs(blob, fileName);
                self.setState({isLoading: false});
            }).catch(function (error) {
                self.setState({isLoading: false});
                showAxiosError(error);
            });
        }
    }

    showButton = (path) => {
        return (<div className="row">
            <Label className="col-sm-7">{path.split(":")[0]}</Label>
            <div className={"col-sm-5"}>
                <button type="button"
                        onClick={async () => {
                            await this.downloadOriginalFile(path.split(":")[1])
                        }}
                        data-toggle="tooltip" data-placement="bottom" title="Belge İndirilebilir"
                        style={{background: 'linear-gradient(rgb(120, 177, 215), rgb(120, 177, 215))'}}
                        rel="tooltip" className="Btn btn-sm btn-icon">
                    <i className="fa fa-download"/>
                </button>
            </div>
        </div>)
    }

    showAll(item) {
        let selectedItem = [];
        let selectedPaths = [];
        let timestamp = "Değiştirme Tarihi: " + moment.utc(item[0]).local().format("DD.MM.YYYY HH:mm:ss");
        let revtype = item[3] === 1 ? "İşlem: Düzenleme " : item[3] === 0 ? "İşlem: Oluşturma " : item[3] === 2 ? "İşlem: Silme " : "İşlem: - ";
        let ad = "Ad: " + item[4];
        let soyad = "Soyad: " + item[47];
        let anneAd = "Anne Adı: " + item[6];
        let babaAd = "Baba Adı: " + item[7];
        let basvuruDurumu = "Başvuru Durumu: " + item[8];
        let cinsiyet = "Cinsiyet: " + item[11];
        let eskisoyad = item[17] === null ? "Eski Soyad: - " : "Eski Soyad: " + item[17];
        let belgeTuru = item[10] === null ? "Belge Türü: - " : "Belge Türü: " + item[10];
        let dogumYeri = item[16] === null ? "Doğum Yeri: - " : "Doğum Yeri: " + item[16];
        let dogumTarihi = item[61] === null ? "Doğum Tarihi: - " : "Doğum Tarihi: " + item[61];
        let evTel = item[18] === null ? "Ev Tel: - " : "Ev Tel: " + item[18];
        let gsm = item[23] === null ? "Cep Tel: - " : "Cep Tel: " + item[23];
        let isTel = item[27] === null ? "İş Tel: - " : "İş Tel: " + item[27];
        let gozlukRuhsatKurum = item[20] === null ? "Gözlükçülük Ruhsatname Kurumu: - " : "Gözlükçülük Ruhsatname Kurumu: " + item[20];
        let gozlukRuhsatNo = item[21] === null ? "Gözlükçülük Ruhsatname No: - " : "Gözlükçülük Ruhsatname No: " + item[21];
        let gozlukRuhsatTarihi = item[62] === null ? "Gözlükçülük Ruhsatname Tarihi: - " : "Gözlükçülük Ruhsatname Tarihi: " + item[62];
        let isTransfered = item[28] === true ? "Transfer Edildi: EVET " : "Transfer Edildi: HAYIR";
        let kamuPersoneli = item[29] === true ? "Kamu Personeli: EVET " : "Kamu Personeli: HAYIR";
        let eczaci = item[66] === true ? "Eczacı: EVET " : "Eczacı: HAYIR";
        let kanGrubu = item[30] === null ? "Kan grubu: - " : "Kan grubu: " + item[27];
        let kendiIsyeri = item[32] === true ? "Kendi İş Yeri: EVET " : "Kendi İş Yeri: HAYIR";
        let kimlikPath = (item[33] === null || item[33] === "") ? "Kimlik : " : item[33].toString().substring(item[33].toString().lastIndexOf('/') + 1) + " :" + item[33];
        let ruhsatPath = (item[46] === null || item[46] === "") ? "Ruhsat : " : item[46].toString().substring(item[46].toString().lastIndexOf('/') + 1) + " :" + item[46];
        let ikametgahPath = (item[25] === null || item[25] === "") ? "İkametgah : " : item[25].toString().substring(item[25].toString().lastIndexOf('/') + 1) + " :" + item[25];
        let fotoPath = (item[19] === null || item[19] === "") ? "Fotoğraf : " : item[19].toString().substring(item[19].toString().lastIndexOf('/') + 1) + " :" + item[19];
        let diplomaPath = (item[14] === null || item[14] === "") ? "Diploma : " : item[14].toString().substring(item[14].toString().lastIndexOf('/') + 1) + " :" + item[14];
        let adliSicilPath = (item[5] === null || item[5] === "") ? "Adli sicil : " : item[5].toString().substring(item[5].toString().lastIndexOf('/') + 1) + " :" + item[5];
        let kimlikTipi = item[35] === null ? "Kimlik Tipi: - " : "Kimlik Tipi: " + item[35];
        let medeniHal = item[36] === null ? "Medeni Hal: - " : "Medeni Hal: " + item[36];
        let mesulMudur = item[37] === true ? "Mesul Müdür: EVET " : "Mesul Müdür: HAYIR";
        let firmaAdi = item[39] === null ? "Firma Adı: - " : "Firma Adı: " + item[39];
        let firmaSahibi = item[40] === null ? "Firma Sahibi: - " : "Firma Sahibi: " + item[40];
        let odaKayitTarihi = "Oda Kayıt Tarihi: " + moment.utc(item[41]).local().format("DD.MM.YYYY HH:mm:ss");
        let odaSicilNo = item[42] === null ? "Oda Sicil No: - " : "Oda Sicil No: " + item[42];
        let ruhsatAktif = item[43] === true ? "Ruhsat Aktif: EVET " : "Ruhsat Aktif: HAYIR";
        let ruhsatNo = item[42] === null ? "Ruhsat No: - " : "Ruhsat No: " + item[44];
        let tckn = item[48] === null ? "TC Kimlik No: - " : "TC Kimlik No: " + item[48];
        let kimlikSeriNo = item[12] === null ? "Kimlik Seri No: - " : "Kimlik Seri No: " + item[12];
        let diplomaNo = item[13] === null ? "Diploma No: - " : "Diploma No: " + item[13];
        let universite = item[50] === null ? "Üniversite: - " : "Üniversite: " + item[50];
        let uyeCalisiyor = item[52] === true ? "Üye Çalışıyor: EVET " : "Üye Çalışıyor: HAYIR";
        let uyelikAktif = item[53] === true ? "Üyelik Aktif: EVET " : "Üyelik Aktif: HAYIR";
        let pasiflikNedeni = item[54] === null ? "Pasiflik Nedeni: - " : "Pasiflik Nedeni: " + item[54];
        let uyelikSonlanmaTarihi = item[55] === null ? "Üyelik Sonlanma Tarihi: - " : "Üyelik Sonlanma Tarihi: " + moment.utc(item[55]).local().format("DD.MM.YYYY HH:mm:ss");
        let vergidairesi = item[56] === null ? "Vergi Dairesi: - " : "Vergi Dairesi: " + item[56];
        let vergiNo = item[57] === null ? "Vergi No: - " : "Vergi No: " + item[57];
        let calismaBelgeli = item[59] === true ? "Çalışma Belgeli: EVET " : "Çalışma Belgeli: HAYIR";
        let kimlikGecerlilikTarihi = item[63] === null ? "TC Kimlik Son Geçerlilik Tarihi: - " : "TC Kimlik Son Geçerlilik Tarihi: " + item[63];
        let mezuniyetTarihi = item[64] === null ? "Mezuniyet Tarihi: - " : "Mezuniyet Tarihi: " + item[64];
        let ruhsatTarihi = item[65] === null ? "Ruhsat Tarihi: - " : "Ruhsat Tarihi: " + item[65];
        let basvuruRedSebebi = item[9] === null ? "Başvuru Reddedilme Sebebi: - " : "Başvuru Reddedilme Sebebi: " + item[9];
        let sehir = item[58] === null ? "Şehir: -" : "Şehir: " + this.getCityName(item[58]);


        selectedItem.push(timestamp);
        selectedItem.push(revtype);
        selectedItem.push(ad);
        selectedItem.push(soyad);
        selectedItem.push(sehir);
        selectedItem.push(odaSicilNo);
        selectedItem.push(odaKayitTarihi);
        selectedItem.push(basvuruDurumu);
        selectedItem.push(basvuruRedSebebi);
        selectedItem.push(dogumYeri);
        selectedItem.push(dogumTarihi);
        selectedItem.push(anneAd);
        selectedItem.push(babaAd);
        selectedItem.push(gsm);
        selectedItem.push(cinsiyet);
        selectedItem.push(eskisoyad);
        selectedItem.push(tckn);
        selectedItem.push(kimlikTipi);
        selectedItem.push(kimlikSeriNo);
        selectedItem.push(kimlikGecerlilikTarihi);
        selectedItem.push(mesulMudur);
        selectedItem.push(belgeTuru);
        selectedItem.push(evTel);
        selectedItem.push(isTel);
        selectedItem.push(gozlukRuhsatKurum);
        selectedItem.push(gozlukRuhsatNo);
        selectedItem.push(gozlukRuhsatTarihi);
        selectedItem.push(isTransfered);
        selectedItem.push(kanGrubu);
        selectedItem.push(kendiIsyeri);
        selectedItem.push(medeniHal);
        selectedItem.push(firmaAdi);
        selectedItem.push(firmaSahibi);
        selectedItem.push(ruhsatAktif);
        selectedItem.push(ruhsatNo);
        selectedItem.push(ruhsatTarihi);
        selectedItem.push(universite);
        selectedItem.push(diplomaNo);
        selectedItem.push(mezuniyetTarihi);
        selectedItem.push(uyeCalisiyor);
        selectedItem.push(uyelikAktif);
        selectedItem.push(pasiflikNedeni);
        selectedItem.push(uyelikSonlanmaTarihi);
        selectedItem.push(vergidairesi);
        selectedItem.push(vergiNo);
        selectedItem.push(calismaBelgeli);
        selectedItem.push(kamuPersoneli);
        selectedItem.push(eczaci);

        selectedPaths.push(kimlikPath);
        selectedPaths.push(ruhsatPath);
        selectedPaths.push(ikametgahPath);
        selectedPaths.push(fotoPath);
        selectedPaths.push(diplomaPath);
        selectedPaths.push(adliSicilPath);


        this.setState({
            showItem: true,
            selectedItem,
            selectedPaths
        })
    }


    render() {
        const {permAddress} = this.state;
        const {workAddress} = this.state;
        const {users} = this.state;
        const {members} = this.state;

        const addressColumns = [
            {
                Header: "Değiştirme Tarihi",
                accessor: "",
                Cell: item => (
                    <label>{item[0] ? moment.utc(item[0]).local().format("DD.MM.YYYY HH:mm:ss") : "-"}</label>)
            },
            {
                Header: "İşlem",
                accessor: "",
                Cell: item => (
                    <label>{item[3] === 1 ? " Düzenleme " : item[3] === 0 ? " Oluşturma " : item[3] === 2 ? " Silme " : "-"}</label>
                )
            },
            {
                Header: "Adres",
                accessor: "",
                Cell: item => (
                    <label>{item[4]}</label>
                )
            },
            {
                Header: "Adres Tipi",
                accessor: "",
                Cell: item => (
                    <label>{item[5] === "WORK" ? " İş " : item[5] === "PERMANENT" ? " İkamet " : "-"}</label>
                )
            },
            {
                Header: "Şehir",
                accessor: "",
                Cell: item => (
                    <label>{item[6] === null ? "-" : this.getCityName(item[6])}</label>
                )
            },
            {
                Header: "İlçe",
                accessor: "",
                Cell: item => (
                    <label>{item[7] === null ? "-" : this.getCitySubDivisionName(item[6], item[7])}</label>
                )
            },
            {
                Header: "Semt",
                accessor: "",
                Cell: item => (
                    <label>{item[9] === null ? "-" : item[9]}</label>
                )
            },

        ];

        const userColumns = [
            {
                Header: "Değiştirme Tarihi",
                accessor: "",
                Cell: item => (
                    <label>{item[0] ? moment.utc(item[0]).local().format("DD.MM.YYYY HH:mm:ss") : "-"}</label>)
            },
            {
                Header: "İşlem",
                accessor: "",
                Cell: item => (
                    <label>{item[3] === 1 ? " Düzenleme " : item[3] === 0 ? " Oluşturma " : item[3] === 2 ? " Silme " : "-"}</label>
                )
            },
            {
                Header: "Email",
                accessor: "",
                Cell: item => (
                    <label>{item[6] === null ? "-" : item[6]}</label>
                )
            },

            {
                Header: "Ad",
                accessor: "",
                Cell: item => (
                    <label>{item[9] === null ? "-" : item[9]}</label>
                )
            },
            {
                Header: "Soyad",
                accessor: "",
                Cell: item => (
                    <label>{item[15] === null ? "-" : item[15]}</label>
                )
            },
            {
                Header: "Kullanıcı Adı",
                accessor: "",
                Cell: item => (
                    <label>{item[16] === null ? "-" : item[16]}</label>
                )
            },
            {
                Header: "Reset Tarihi",
                accessor: "",
                Cell: item => (
                    <label>{item[13] ? moment.utc(item[13]).local().format("DD.MM.YYYY HH:mm:ss") : "-"}</label>)
            },


        ];

        const memberColumns = [
            {
                Header: "Değiştirme Tarihi",
                accessor: "",
                Cell: item => (
                    <label>{item[0] ? moment.utc(item[0]).local().format("DD.MM.YYYY") : "-"}</label>)
            },
            {
                Header: "İşlem",
                accessor: "",
                Cell: item => (
                    <label>{item[3] === 1 ? " Düzenleme " : item[3] === 0 ? " Oluşturma " : item[3] === 2 ? " Silme " : "-"}</label>
                )
            },
            {
                Header: "Ad",
                accessor: "",
                Cell: item => (
                    <label>{item[4] === null ? "-" : item[4]}</label>
                )
            },
            {
                Header: "Soyad",
                accessor: "",
                Cell: item => (
                    <label>{item[47] === null ? "-" : item[47]}</label>
                )
            },
            // {
            //     Header: "Sicil No",
            //     accessor: "",
            //     Cell: item => (
            //         <label>{item[42] === null ? "-" : item[42]}</label>
            //     )
            // },
            {
                Header: "Firma Adı",
                accessor: "",
                Cell: item => (
                    <label>{item[39] === null ? "-" : item[39]}</label>
                )
            },
            {
                Header: "Üyelik Durumu",
                accessor: "",
                Cell: item => (
                    <label>{item[53] === true ? " Aktif " : " Pasif "}</label>
                )
            },
            // {
            //     Header: "Çalışma Durumu",
            //     accessor: "",
            //     Cell: item => (
            //         <label>{item[52] === true ? " Çalışıyor " : " Çalışmıyor "}</label>
            //     )
            // },
            {
                Header: "İşlemler",
                accessor: "",
                sortable: false,
                Cell: item => (
                    <div>
                        <button type="button"
                                onClick={() => this.showAll(item)}
                                data-toggle="tooltip" data-placement="bottom" title="Tümünü Göster"
                                style={{background: 'linear-gradient(rgb(120, 177, 215), rgb(120, 177, 215))'}}
                                rel="tooltip" className="Btn btn-sm btn-icon">
                            <i className="fa fa-eye"/>
                        </button>
                    </div>

                )
            }


        ];

        return (
            <div className="content user-form-container" style={{width:"100%"}}>
                <Nav tabs style={{width:"100%", gap:"10px"}}>
                    <NavItem>
                        <NavLink
                            className={classnames({active: this.state.activeTab === '1'})}
                            onClick={() => {
                                this.toggle('1');
                            }}
                            style={{width:"150px", textAlign:"left"}}
                        >
                            Üye Tarihçesi
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink
                            className={classnames({active: this.state.activeTab === '2'})}
                            onClick={() => {
                                this.toggle('2');
                            }}
                            style={{width:"150px", textAlign:"left"}}
                        >
                            Kullanıcı Tarihçesi
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink
                            className={classnames({active: this.state.activeTab === '3'})}
                            onClick={() => {
                                this.toggle('3');
                            }}
                            style={{width:"150px", textAlign:"left"}}
                        >
                            Adres Tarihçesi
                        </NavLink>
                    </NavItem>
                </Nav>
                <TabContent activeTab={this.state.activeTab} className="tab-content" style={{width:"103%"}}>
                    <TabPane tabId="1">
                        <div className="row baseBackground">
                            {this.state.showItem === false ?
                                <div className="card-body">
                                    <Table
                                        loading={this.state.loading}
                                        loadingText="Kayıtlar getiriliyor..."
                                        content={members}
                                        total={this.state.total}
                                        page={this.state.page}
                                        manual={this.state.manual}
                                        size={this.state.size}
                                        options={["5", "10", "20", "50", "100"]}
                                        columns={memberColumns}
                                        fetchData={this.listMembers}
                                        style={{width:"100%", marginTop:"25px"}}
                                    />
                                </div>
                                :
                                <div>
                                    <div className="card-bod mt-1y">
                                        <Label><br/><h5> Üye Bilgileri </h5></Label>
                                        {this.state.selectedItem.map(str => <p><b>{str}</b></p>)}
                                    </div>
                                    <div className="card-body mt-1">
                                        <h6 style={{fontWeight: 'bold', color : 'cornflowerblue'}}> Dosyalar </h6>
                                        {this.state.selectedPaths.map(str => this.showButton(str))}
                                    </div>
                                </div>

                            }

                        </div>
                    </TabPane>
                    <TabPane tabId="2">
                        <div className="row baseBackground">
                            <div className="card-body">
                                <Table
                                    loading={this.state.loading}
                                    loadingText="Kayıtlar getiriliyor..."
                                    content={users}
                                    total={this.state.total}
                                    page={this.state.page}
                                    manual={this.state.manual}
                                    size={this.state.size}
                                    options={["5", "10", "20", "50", "100"]}
                                    columns={userColumns}
                                    fetchData={this.listUsers}
                                    style={{width:"100%", marginTop:"25px"}}
                                />
                            </div>
                        </div>
                    </TabPane>
                    <TabPane tabId="3">
                        <div className="row baseBackground">
                            <div className="card-body">
                                <Table
                                    loading={this.state.loading}
                                    loadingText="Kayıtlar getiriliyor..."
                                    content={workAddress}
                                    total={this.state.total}
                                    page={this.state.page}
                                    manual={this.state.manual}
                                    size={this.state.size}
                                    options={["5", "10", "20", "50", "100"]}
                                    columns={addressColumns}
                                    fetchData={this.listWorkAddress}
                                    style={{width:"100%", marginTop:"25px"}}
                                />
                            </div>
                        </div>
                        <div className="row baseBackground">
                            <div className="card-body">
                                <Table
                                    loading={this.state.loading}
                                    loadingText="Kayıtlar getiriliyor..."
                                    content={permAddress}
                                    total={this.state.total}
                                    page={this.state.page}
                                    manual={this.state.manual}
                                    size={this.state.size}
                                    columns={addressColumns}
                                    fetchData={this.listPermAddress}
                                    style={{width:"100%", marginTop:"25px"}}
                                />
                            </div>
                        </div>
                    </TabPane>
                </TabContent>
            </div>
        )
    }
}

export default MemberTransactionHistory;


// WEBPACK FOOTER //
// ./src/page/memberList/MemberTransactionHistory.js